<template>
  <div id="app" style="width:100%; text-align: left;" >
    <Designer/>
  </div>
</template>

<script>

import Designer from './components/Designer'

export default {
  name: 'App',
  components: {
    Designer
  }
}
</script>

<style lang="scss">
   @import './src/assets/site.scss';
</style>

